import { render, staticRenderFns } from "./incomeItem.vue?vue&type=template&id=4657e159&scoped=true&"
import script from "./incomeItem.vue?vue&type=script&lang=js&"
export * from "./incomeItem.vue?vue&type=script&lang=js&"
import style0 from "./incomeItem.vue?vue&type=style&index=0&id=4657e159&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657e159",
  null
  
)

export default component.exports